import { useState, useEffect } from "react";
import styles from "./CarouselTemporadasPPE.module.css";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import { ModalDetallesEventoTemporada } from "../ModalDetallesEventoTemporada/ModalDetallesEventoTemporada";
import nfl from "../../../assets/img/adultos/nfl.png";
import nflM from "../../../assets/img/adultos/nflM.png";
import vextremo from "../../../assets/img/adultos/vextremo-desktop.jpg";
import vextremoM from "../../../assets/img/adultos/vextremo-mobile.jpg";
import tvhot from "../../../assets/img/adultos/tvhot-desktop.jpg";
import tvhotM from "../../../assets/img/adultos/tvhot-mobile.jpg";
import Loading from "../../../General/Loading";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ConsultaWS } from "../../../Commons/ServiciosBase";
import { Collapse, Row } from "react-bootstrap";
import flecha from "../../../assets/img/Iconos/flechaAbajo.svg";
import {
  builtInputVarRecargaConsultaPrecioRecargaInput,
  ConsultaPrecioRecarga_Parametros,
  RecargaConsultaPrecioRecarga_Entrada,
  RecargaConsultaPrecioRecarga_Respuesta,
} from "../../../Commons/Services/ConsultaPrecioRecargaRest";
import {
  builtConsultaPagosPorEventoRestEntrada,
  ConsultaPagosPorEventoRest_Entrada,
  ConsultaPagosPorEventoRest_Parametros,
  ConsultaPagosPorEventoRest_Respuesta,
} from "../../../Commons/Services/ConsultaPagosPorEventoRest";
export const CarouselEventos = ({ aviso }: any) => {
  const [muestraModal, setMuestraModal] = useState<any>([]);
  const [eventos, setEventos] = useState<any>([]);
  const [loading, isLoading] = useState(false);
  const [saldoPre, setSaldoPre] = useState<string>();
  const [cSlidesShow, setCSlidesShow] = useState(0);

  const [collapse, setCollapse] = useState(false);

  const muestraCollapse = () => {
    setCollapse(!collapse);
  };
  interface Estado {
    id: number;
    muestra: boolean;
  }

  const handleClose = (index: number) => {
    setMuestraModal(
      muestraModal.map((e: Estado) =>
        e.id === index ? { ...e, muestra: false } : e
      )
    );
  };

  const handleShow = (index: number) => {
    setMuestraModal(
      muestraModal.map((e: Estado) =>
        e.id === index ? { ...e, muestra: true } : e
      )
    );
  };

  const doConsultaPagosPorEvento = async () => {
    isLoading(true);
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultaPagosPorEventoDO: ConsultaPagosPorEventoRest_Entrada =
      builtConsultaPagosPorEventoRestEntrada(
        "2",
        `${sessionStorage.getItem("banderaHD")}`,
        `${sessionStorage.getItem("Paquete")}`,
        `${sessionStorage.getItem("pais")}`,
        `%N%`
      );

    let ConsultaPagosPorEventoParametros =
      ConsultaPagosPorEventoRest_Parametros(ConsultaPagosPorEventoDO);

    let ConsultaPagosPorEventoRespuesta: ConsultaPagosPorEventoRest_Respuesta =
      await ConsultaWS(ConsultaPagosPorEventoParametros);

    if (
      ConsultaPagosPorEventoRespuesta.PPE &&
      ConsultaPagosPorEventoRespuesta.PPE != null &&
      ConsultaPagosPorEventoRespuesta.PPE.length > 0
    ) {
      let arreglo = ConsultaPagosPorEventoRespuesta.PPE;
      let arregloIndices: Estado[] = [];

      arreglo.forEach((element: object, i: number) => {
        arregloIndices.push({ id: i, muestra: false });
      });

      setEventos(arreglo);
      setCSlidesShow(arreglo.length);
      setMuestraModal(arregloIndices);
      isLoading(false);
    } else {
      console.warn("NO HAY DATOS PARA PROCESAR");
      setEventos([]);
      setMuestraModal(false);
      isLoading(false);
    }
  };

  const sliderSettings = {
    arrows: eventos.length >= 4 ? true : false,
    slidesToShow: 4,
    slidesToScroll: 2,
    infinite: eventos.length >= 4 ? true : false,
    emulateTouch: eventos.length >= 4 ? true : false,
    dots: eventos.length >= 4 ? true : false,
    speed: 1000,
    autoplay: eventos.length >= 4 ? true : false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: eventos.length >= 4 ? true : false,
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: eventos.length >= 4 ? true : false,
          emulateTouch: eventos.length >= 4 ? true : false,
          dots: eventos.length >= 4 ? true : false,
          speed: 1000,
          autoplay: eventos.length >= 4 ? true : false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          arrows: eventos.length >= 4 ? true : false,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: eventos.length >= 4 ? true : false,
          emulateTouch: eventos.length >= 4 ? true : false,
          dots: eventos.length >= 4 ? true : false,
          speed: 1000,
          autoplay: eventos.length >= 4 ? true : false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: eventos.length >= 4 ? true : false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: eventos.length >= 4 ? true : false,
          emulateTouch: eventos.length >= 4 ? true : false,
          dots: eventos.length >= 4 ? true : false,
          speed: 1000,
          autoplay: eventos.length >= 4 ? true : false,
        },
      },
    ],
  };

  const verificaSaldoPrepago = async (cuenta: any) => {
    const RecargaConsultaPrecioRecargaDO: RecargaConsultaPrecioRecarga_Entrada =
      builtInputVarRecargaConsultaPrecioRecargaInput(`${cuenta}`);
    let par = ConsultaPrecioRecarga_Parametros(RecargaConsultaPrecioRecargaDO);
    let RecargaConsultaPrecioRecargaRespuesta: RecargaConsultaPrecioRecarga_Respuesta =
      await ConsultaWS(par);

    if (
      RecargaConsultaPrecioRecargaRespuesta.EBMHeaderResponse &&
      RecargaConsultaPrecioRecargaRespuesta.EBMHeaderResponse.ErrorNegocio
        .Estado == "ok" &&
      RecargaConsultaPrecioRecargaRespuesta.EBMHeaderResponse.ErrorTecnico
        .code === "ok"
    ) {
      let cadena =
        RecargaConsultaPrecioRecargaRespuesta
          .Recarga_consultaPrecioRecarga_Salida.SALDO;
      setSaldoPre(cadena);
    } else {
      console.error(RecargaConsultaPrecioRecargaRespuesta.EBMHeaderResponse);
    }
  };

  const formateaTitulo = (titulo: any) => {
    if (titulo !== null || titulo !== "" || typeof titulo !== "undefined") {
      titulo = titulo.replaceAll("-", "");
      titulo = titulo.replaceAll("HD", "");
      titulo = titulo.slice(0, 17);

      return titulo;
    } else {
      return "N/E";
    }
  };

  useEffect(() => {
    doConsultaPagosPorEvento();

    if (sessionStorage.getItem("tipoCliente") === "PRE") {
      verificaSaldoPrepago(sessionStorage.getItem("cuenta"));
    }
  }, []);

  const imagenesHardcode = [nfl];
  const imagenesHardcodeModal = [nflM];
  const sinopsis = [
    "La cobertura más amplia de fútbol americano se encuentra en NFL Sunday Ticket; más de 150 partidos de la temporada regular y grandes encuentros fecha a fecha. De Septiembre a Enero, no te pierdas a los mejores equipos y apoya a tu favorito; NFL Sunday Ticket te lleva más adrenalina que cualquiera.",
  ];

  return (
    <>
      <Loading isLoading={loading} />

      <div id="big" className="d-none d-xl-block d-lg-block ">
        {eventos.length !== 0 ? (
          <Container fluid>
            <Row>
              <Col>
                <h1 className={styles.tituloPagina2}>
                  <span className="textoSpectrum">Contratación: Eventos</span>
                </h1>
                <p className={styles.subtituloPagina2}>
                  Contrata tu programa, serie o deporte favorito, para que no te
                  pierdas ni un minuto.
                </p>
              </Col>
            </Row>
          </Container>
        ) : (
          <></>
        )}
        <Container className={styles.contenedor} fluid>
          <Slider {...sliderSettings}>
            {eventos.map((item: any, index: number) => (
              <Col
                xs={12}
                md={6}
                lg={4}
                className={styles.espacioCard}
                key={index}
              >
                <Card className={styles.card}>
                  <Card.Img
                    src={imagenesHardcode[index]}
                    className={styles.img}
                  />
                  <Card.Body className={styles.cardBody}>
                    <h3 className={styles.titulo}>
                      {formateaTitulo(item.DISPLAY_VALUE)}
                    </h3>
                    <Card.Text className={styles.info}>
                      <p className={styles.precioCard}>
                        <b>${item.PRICE}</b>
                      </p>
                      <p className={styles.allday}>All day</p>
                    </Card.Text>
                    <Button
                      className={styles.boton}
                      onClick={() => handleShow(index)}
                    >
                      Contratar
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
            {eventos.length === 3 ? <Col></Col> : <></>}
            {eventos.length === 2 ? (
              <>
                <Col></Col>
                <Col></Col>
              </>
            ) : (
              <></>
            )}
            {eventos.length === 1 ? (
              <>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </>
            ) : (
              <></>
            )}
          </Slider>
        </Container>
      </div>

      {/***************************
Inicia seccion para celulares
*****************************/}

      <div id="small" className="d-lg-none d-xl-none">
        <Container>
          {eventos.length !== 0 ? (
            <Row>
              <hr className={styles.lineaSup} />
              <Col>
                <p
                  style={{ marginBottom: "1vw" }}
                  className={styles.peliculasSmall}
                >
                  <b>Eventos</b>
                </p>
              </Col>
              <Col>
                <div className={styles.alineaFlecha}>
                  <img
                    src={flecha}
                    aria-controls="example-collapse-text"
                    aria-expanded={collapse}
                    className={
                      collapse === true ? styles["rota"] : styles["noRota"]
                    }
                    onClick={muestraCollapse}
                  />
                </div>
              </Col>
            </Row>
          ) : (
            <></>
          )}

          {eventos.map((item: any, index: number) => (
            <Collapse in={collapse}>
              <Row>
                <Col className={styles.cardCollapse}>
                  <Card
                    className={styles.cardImgSmall}
                    onClick={() => handleShow(index)}
                  >
                    <Row>
                      <Col xs={4} className={styles.contenedorImgSmall}>
                        <div>
                          <Card.Img
                            src={imagenesHardcode[index]}
                            className={styles.imgSmall}
                          />
                        </div>
                      </Col>
                      <Col xs={8} className={styles.contenedorItemSmall}>
                        <Card.Text className={styles.info}>
                          <p className={styles.precioCard}>
                            <b>{formateaTitulo(item.DISPLAY_VALUE)}</b>
                          </p>
                          <p className={styles.allday}>${item.PRICE}/All day</p>
                        </Card.Text>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Collapse>
          ))}
          {eventos.length !== 0 ? (
            <Row>
              <hr className={styles.lineaInf} />
            </Row>
          ) : (
            <></>
          )}
        </Container>
      </div>

      {eventos.map((item: any, index: number) => (
        <ModalDetallesEventoTemporada
          key={index}
          show={muestraModal[index].muestra}
          handleClose={() => handleClose(index)}
          titulo={item.DISPLAY_VALUE}
          precio={item.PRICE}
          canal={item.CHANNEL}
          canalDisplay={item.CHANNEL_DISPLAY}
          idioma={item.IDIOMA}
          subtitulos={item.SUBTITULOS}
          // img={"https://serviciosenlinea.sky.com.mx/sky/imagenes/160X240/" + item.img }
          img={imagenesHardcodeModal[index]}
          //imgR={imagenesHardcode[index]}
          sinopsis={sinopsis}
          area="Administracion de senal"
          subarea="Solicitud de OPPV"
          saldo={saldoPre}
          aviso={aviso}
        />
      ))}
    </>
  );
};
